import React from 'react'
import { Trans } from '@lingui/macro'
import Link from '../common/navigation/Link'

import './MoreInfo.scss'

const MORE_INFO_CONTENT = (
  <Trans>
    <p>
      <span>Visit </span>
      <Link href="https://www.yoti.com">Yoti.com</Link>
      <span> for more information</span>
    </p>
  </Trans>
)

const MoreInfo = () => (
  <div className="more-info">
    {MORE_INFO_CONTENT}
  </div>
)

export default MoreInfo
